/* When a project created with template containg Conditional variables in task description, it carries the conditionalVariables tag with it,
   when that project is used to create a new template we remove the older conditionalVariables variables tag in this function.  */
export const formatConditionalVariables = (taskDescription: string) => {
  if (taskDescription.includes('conditionalVariables')) {
    if (taskDescription.includes('{{#if')) {
      return taskDescription;
    }
    const innterTextRegex = /<p>.*?<\/p>/;
    const description = taskDescription.match(innterTextRegex);

    if (description) {
      return description[0];
    }
  }

  return taskDescription;
};
